import React, { PropsWithChildren } from 'react';
import { useTabContainer } from '../ContainerContext';
import { NavLink as NavLinkComponent } from 'reactstrap';
import './index.css';

const NavLink = ({ tabId, children }: PropsWithChildren<{ tabId: string }>) => {
  const { activeTab, setActiveTab } = useTabContainer();
  return (
    <NavLinkComponent
      className={`unsw-tabs-tab ${activeTab === tabId ? 'active' : ''}`}
      onClick={() => setActiveTab(tabId)}>
      {children}
    </NavLinkComponent>
  );
};

export default NavLink;
